import React from 'react'
import SideNavigationBar from '../../reusables/SideNavigationBar/SideNavigationBar'
import CreateTable from './CreateStudentTable'
import { useLocation } from 'react-router-dom';
import { useNavigate, useSearchParams } from 'react-router-dom';

const College1x1StudentDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  let college_data_id = location.state?.college_data_id
  let college_data_name = location.state?.college_data_name || searchParams.get("college_name")
  let batchName = location.state?.batchName
  let batchid = location.state?.batchid
  let process_id = location.state?.process_id
  let searched = location.state?.searched
  let sku_name = location.state?.sku_name
  let features = location.state?.features
  console.log("features", features);
  return (
    <div>
      <SideNavigationBar />
      <CreateTable college_data_id={college_data_id} process_id={process_id} college_data_name={college_data_name} batchName={batchName} batchid={batchid} sku_name={sku_name} features={features} searched={searched}/>
    </div>
  )
}

export default College1x1StudentDetails
